/**
 * URL config settings
 */
export const API_URL =
  process.env.NODE_ENV === "development"
    ? "https://dev.api.occuspace.io"
    : "https://api.occuspace.io";

export const CALLBACK_URL = `${window.location.origin}/authorized`;
